<template>
  <v-row>
    <v-col cols="7" class="mx-n4">
      <v-card-title>Surcharger le titre H1</v-card-title>
    </v-col>
    <v-col cols="10" class="mt-n8">
      <v-text-field
        v-model="actionValue.title"
        label="Titre H1"
        outlined
        dense
        hide-details
      />
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({ action: { type: Object, required: true } });

const actionValue = ref(props.action);
</script>
